import { DEFAULT_MODE, makeThemeColor, PRIMARY } from '@tornado-rdk/theme';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { FONT, getFont } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../../../tornado/utils/style';
import { middle } from '../../../tornado/utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  text: makeThemeColor(PRIMARY),
};

export const TEXT_MARGIN = {
  [HD]: 8,
  [FULL_HD]: 8,
};

export const BUTTONS_MARGIN = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const SPINNER_SIZE = {
  [HD]: 32,
  [FULL_HD]: 32,
};

export const getInitialStyle = ({ screenSize = FULL_HD, colorMode = DEFAULT_MODE } = defaultContext) => ({
  flex: {
    direction: 'column',
  },
  Title: {
    text: {
      ...getFont(FONT.PARIS_2, screenSize),
      textColor: colors.text[colorMode],
    },
    flexItem: {
      marginBottom: TEXT_MARGIN[screenSize],
    },
  },
  Description: {
    text: {
      ...getFont(FONT.OTTAWA_1, screenSize),
      textColor: colors.text[colorMode],
    },
  },
  Buttons: {
    flexItem: {
      marginTop: BUTTONS_MARGIN[screenSize],
    },
    flex: {
      alignItems: 'center',
      justifyContent: 'center',
      direction: 'row',
    },
    Accept: {
      flexItem: {
        marginRight: BUTTONS_MARGIN[screenSize],
      },
    },
    Decline: {},
  },
  Spinner: {
    visible: false,
    w: SPINNER_SIZE[screenSize],
    h: SPINNER_SIZE[screenSize],
    x: middle,
    mountX: 0.5,
    flexItem: {
      marginTop: BUTTONS_MARGIN[screenSize],
    },
  },
});
